import angular from 'angular';
import ngRoute from 'angular-route';
import storyApp from './storyApp';
import RouteCtrl from './controllers/routeCtrl';
import StoryCtrl from './controllers/storyCtrl';
import storyProperties from './factories/storyProperties';
import storyInView from './factories/storyInView';
import storyScroll from './factories/storyScroll';
import threeThingsAPI from './factories/threeThingsAPI';
import cookiePolyfillService from './factories/cookiePolyfillService';
import trackingUtils from './factories/trackingUtils';
import storiesFilterService from './factories/storiesFilterService';
import cqArticleService from './factories/cqArticleService';
import storyEvents from './factories/storyEvents.service';
import metaDataFactory from './factories/metaDataFactory';
import threeThingEvents from './factories/threeThingEvents';
import htmlCompile from './directives/htmlCompile';
import parselyService from './factories/parselyService';
import ellipsizeTextService from './factories/ellipsizeTextService';


// WEBPACK FOOTER //
// ./assets/components/threethings/threethings.js